import { Injectable } from '@angular/core';
import { SchedulerSetup } from '@app/core/components/scheduler/scheduler.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class DiaryService {
    constructor(private dataTask: DataTaskService) {}

    public async getSetting(): Promise<DiarySetting> {
        return (await this.dataTask.Post(841, {}))[0] as DiarySetting;
    }

    public listPortalUsers(): Promise<DiaryPortalUser[]> {
        return this.dataTask.Post(842, {});
    }

    public listTasks(setting: DiarySetting): Promise<DiaryTask[]> {
        return this.dataTask.Post(843, setting);
    }

    public listOwners(setting: DiarySetting): Promise<DiaryOwner[]> {
        return this.dataTask.Post(844, setting);
    }

    public deleteCustact(id: string | number): Promise<unknown> {
        return this.dataTask.Post(136, { custact_no: id });
    }

    public updateItem(task: DiaryTask): Promise<unknown> {
        return this.dataTask.Post(849, { ...task, webpagename: 'diary' });
    }
}

export interface DiarySetting extends SchedulerSetup {
    portal_user_keyno: string | number;
    selectedview?: string;
    breakpoint?: string;
}

export interface DiaryPortalUser {
    item_id: string | number;
    item_name: string;
}

export interface DiaryOwner {
    color?: string;
    orderby?: string;
    portal_user_keyno: string | number;
    portal_user_name: string;
}

export interface DiaryTask {
    id: string | number;
    start?: Date | string;
    end?: Date | string;
    microsoft_graph_event_id?: string;
    sync_with_microsoft_365?: string;
    [key: string]: unknown;
}
